export default {
  box: {
    'maximize': 'Teljes méret',
    'minimize': 'Kis méret'
  }
}
